/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import ReactDOM from 'react-dom';

import axios from 'axios';

import 'react-notification-alert/dist/animate.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import '@fullcalendar/common/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'select2/dist/css/select2.min.css';
import 'quill/dist/quill.core.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'assets/vendor/nucleo/css/nucleo.css';
import 'remixicon/fonts/remixicon.css';
import 'assets/scss/argon-dashboard-pro-react.scss?v1.2.0';
import { ParallaxProvider } from 'react-scroll-parallax';

import App from 'views/App';

import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import promiseMiddleware from 'redux-promise';
import ReduxThunk from 'redux-thunk';
import persistedReducer from '_reducers/index';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

const createStoreWithMiddleware = applyMiddleware(promiseMiddleware, ReduxThunk)(createStore);
const store = createStoreWithMiddleware(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const persistor = persistStore(store);

axios.defaults.baseURL = process.env.REACT_APP_URI;
axios.defaults.withCredentials = true;

// if (process.env.NODE_ENV === 'production') {
//   console.log = () => {};
// }

ReactDOM.render(
  <Provider
    store={store}
  >
    <PersistGate persistor={persistor}>
      <ParallaxProvider>
        <App />
      </ParallaxProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
